import React from 'react'

function InactiveRolesToggle({ params, setParams }) {
  return (
    <div className="form-check form-switch mt-1">
      <input
        className="form-check-input"
        type="checkbox"
        id="active"
        checked={params.activeRoles}
        onChange={() => setParams({ ...params, activeRoles: !params.activeRoles })}
      />
      <label className="form-check-label" htmlFor="active">
        Hide Inactive
      </label>
    </div>
  )
}

export default InactiveRolesToggle
